export interface PricingFeature {
  text: string
  icon?:
    | 'check'
    | 'zap'
    | 'users'
    | 'trending'
    | 'shield'
    | 'clock'
    | 'sparkles'
}

export interface PricingPlan {
  name: string
  description: string
  monthlyPrice: number
  yearlyPrice: number
  features: PricingFeature[]
  ctaText: string
  ctaLink: string
  recommended?: boolean
  variant?: 'light' | 'dark'
}

export const pricingPlans: PricingPlan[] = [
  {
    name: 'Core',
    description: 'For investors closing 0-5 deals per month',
    monthlyPrice: 997,
    yearlyPrice: 798,
    ctaText: 'Join Beta',
    ctaLink: '/trial',
    recommended: false,
    variant: 'light',
    features: [
      {
        text: '1 target market',
      },
      {
        text: '3,000 automated offers/month',
      },
      {
        text: 'AI-powered property analysis',
      },
      {
        text: 'Response tracking & management',
      },
      {
        text: 'Deal pipeline analytics',
      },
      {
        text: 'Email & phone support',
      },
      {
        text: 'Multi-market campaigns',
      },
      {
        text: 'Custom offer templates',
      },
    ],
  },
  {
    name: 'Scale',
    description: 'For investors closing 10+ deals per month',
    monthlyPrice: 1597,
    yearlyPrice: 1278,
    ctaText: 'Join Beta',
    ctaLink: '/trial',
    recommended: true,
    variant: 'dark',
    features: [
      {
        text: 'Unlimited markets',
      },
      {
        text: 'Unlimited automated offers',
      },
      {
        text: 'Custom AI training',
      },
      {
        text: 'White-labeled offers',
      },
      {
        text: 'API access',
      },
      {
        text: 'Dedicated account manager',
      },
      {
        text: 'Priority support (24/7)',
      },
      {
        text: 'Custom integrations',
      },
    ],
  },
]
